import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('shared_business_rule_validation', '/shared_business_rules_validation')
const actions = generator.generate()

export default actions
